module.exports = __webpack_public_path__ + "static/media/8.9e0479ea.mp4";